export const updateFormConfig = {
  underBtn: {
    title: 'Continue',
    show: false,
  },
  formWidth: '50%',
  formItems: [
    {
      field: 'visaCardName',
      type: 'password',
      label: 'visaCardName',
      maxlength: '35',
      minlength: '2', // Character number must be more than one.
      errorMsg: '',
      errorShow: false,
      changeformItemBoxStyle: true,
      contentInputGroupMarginTop: '4px',
      icon: 'off',
    },
    {
      field: 'visaCardNum',
      type: 'password',
      maxlength: 19,
      label: 'visaCardNum',
      errorMsg: '',
      errorShow: false,
      icon: 'off',
      needEyeIcon: true,
      changeformItemBoxStyle: true,
      contentInputGroupMarginTop: '4px',
      icon: 'off',
    },
    {
      type: 'card',
      children: [
        {
          field: 'cardExpiryDate',
          label: 'cardExpiryDate',
          inputType: 'password',
          placeholder: 'my-placeholder',
          subLabel: '',
          errorMsg: '',
          errorShow: false,
          maxlength: 5,
          on: false,
          formItemLabelMarginBottom: '4px',
          iconShow2: true,
        },
        {
          field: 'cardNum',
          label: 'cardNum',
          subLabel: '',
          inputType: 'password',
          errorMsg: '',
          errorShow: false,
          iconShow: true,
          maxlength: 4,
          formItemLabelMarginBottom: '4px',
          on: false,
          iconShow2: true,
        },
      ],
    },
  ],
};
